"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _ErrorApi = require("./../utils/ErrorApi");

var _ErrorApi2 = _interopRequireDefault(_ErrorApi);

var _JsonFetch = require("./../utils/JsonFetch");

var _JsonFetch2 = _interopRequireDefault(_JsonFetch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (serverContextPath === null) {
    console.error("Global variable serverContextPath is not defined (is null)!");
}

var EoApi = function () {
    function EoApi() {
        (0, _classCallCheck3.default)(this, EoApi);
    }

    (0, _createClass3.default)(EoApi, null, [{
        key: "findPracovnici",


        // static findPracovniciPravoIsepOpis(fulltext) {
        //     const uri = EoApi.pracovnici;
        //     return ErrorApi.responseResolver(JsonFetch.get(uri, {fulltext}));
        // }

        value: function findPracovnici(fulltext, proSpustenouAplikaci, max) {
            var uri = EoApi.pracovnici;
            return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, {
                fulltext: fulltext,
                proSpustenouAplikaci: proSpustenouAplikaci,
                max: max
            }));
        }
    }]);
    return EoApi;
}();

EoApi.baseUrl = serverContextPath + "/api";
EoApi.eo = EoApi.baseUrl + '/eo';
EoApi.pracovnici = EoApi.eo + '/pracovnici';
exports.default = EoApi;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9saWIvYXBpL0VvQXBpLmpzeCJdLCJuYW1lcyI6WyJzZXJ2ZXJDb250ZXh0UGF0aCIsImNvbnNvbGUiLCJlcnJvciIsIkVvQXBpIiwiZnVsbHRleHQiLCJwcm9TcHVzdGVub3VBcGxpa2FjaSIsIm1heCIsInVyaSIsInByYWNvdm5pY2kiLCJFcnJvckFwaSIsInJlc3BvbnNlUmVzb2x2ZXIiLCJKc29uRmV0Y2giLCJnZXQiLCJiYXNlVXJsIiwiZW8iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7O0FBQUE7Ozs7QUFDQTs7Ozs7O0FBRUEsSUFBSUEsc0JBQXNCLElBQTFCLEVBQWdDO0FBQzVCQyxZQUFRQyxLQUFSLENBQWMsNkRBQWQ7QUFDSDs7SUFFb0JDLEs7Ozs7Ozs7OztBQUtqQjtBQUNBO0FBQ0E7QUFDQTs7dUNBRXNCQyxRLEVBQVVDLG9CLEVBQXNCQyxHLEVBQUs7QUFDdkQsZ0JBQU1DLE1BQU1KLE1BQU1LLFVBQWxCO0FBQ0EsbUJBQU9DLG1CQUFTQyxnQkFBVCxDQUEwQkMsb0JBQVVDLEdBQVYsQ0FBY0wsR0FBZCxFQUFtQjtBQUNoREgsa0NBRGdEO0FBRWhEQywwREFGZ0Q7QUFHaERDO0FBSGdELGFBQW5CLENBQTFCLENBQVA7QUFLSDs7Ozs7QUFqQmdCSCxLLENBQ1ZVLE8sR0FBd0JiLGlCO0FBRGRHLEssQ0FFVlcsRSxHQUFzQlgsTUFBTVUsT0FBTixHQUFnQixLO0FBRjVCVixLLENBR1ZLLFUsR0FBc0JMLE1BQU1XLEVBQU4sR0FBVyxhO2tCQUh2QlgsSyIsImZpbGUiOiJFb0FwaS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBFcnJvckFwaSBmcm9tIFwiLi8uLi91dGlscy9FcnJvckFwaVwiXG5pbXBvcnQgSnNvbkZldGNoIGZyb20gXCIuLy4uL3V0aWxzL0pzb25GZXRjaFwiXG5cbmlmIChzZXJ2ZXJDb250ZXh0UGF0aCA9PT0gbnVsbCkge1xuICAgIGNvbnNvbGUuZXJyb3IoXCJHbG9iYWwgdmFyaWFibGUgc2VydmVyQ29udGV4dFBhdGggaXMgbm90IGRlZmluZWQgKGlzIG51bGwpIVwiKTtcbn1cblxuZXhwb3J0IGRlZmF1bHQgY2xhc3MgRW9BcGkge1xuICAgIHN0YXRpYyBiYXNlVXJsID0gICAgICAgICAgICBgJHtzZXJ2ZXJDb250ZXh0UGF0aH0vYXBpYDtcbiAgICBzdGF0aWMgZW8gPSAgICAgICAgICAgICAgICAgIEVvQXBpLmJhc2VVcmwgKyAnL2VvJztcbiAgICBzdGF0aWMgcHJhY292bmljaSA9ICAgICAgICAgIEVvQXBpLmVvICsgJy9wcmFjb3ZuaWNpJztcblxuICAgIC8vIHN0YXRpYyBmaW5kUHJhY292bmljaVByYXZvSXNlcE9waXMoZnVsbHRleHQpIHtcbiAgICAvLyAgICAgY29uc3QgdXJpID0gRW9BcGkucHJhY292bmljaTtcbiAgICAvLyAgICAgcmV0dXJuIEVycm9yQXBpLnJlc3BvbnNlUmVzb2x2ZXIoSnNvbkZldGNoLmdldCh1cmksIHtmdWxsdGV4dH0pKTtcbiAgICAvLyB9XG5cbiAgICBzdGF0aWMgZmluZFByYWNvdm5pY2koZnVsbHRleHQsIHByb1NwdXN0ZW5vdUFwbGlrYWNpLCBtYXgpIHtcbiAgICAgICAgY29uc3QgdXJpID0gRW9BcGkucHJhY292bmljaTtcbiAgICAgICAgcmV0dXJuIEVycm9yQXBpLnJlc3BvbnNlUmVzb2x2ZXIoSnNvbkZldGNoLmdldCh1cmksIHtcbiAgICAgICAgICAgIGZ1bGx0ZXh0LFxuICAgICAgICAgICAgcHJvU3B1c3Rlbm91QXBsaWthY2ksXG4gICAgICAgICAgICBtYXhcbiAgICAgICAgfSkpO1xuICAgIH1cbn1cbiJdfQ==